<template>

      <div class="item">
          <div class="pic" :style="'background-image:url(' + item.pic_tumb + ')'" @click="$bus.$emit('open_widget', item)"></div>
          <a class="play_btn" @click="$emit('play', item)"><i class="fas fa-play"></i></a>
          <div class="album_icon" v-if="item.album_type == 1 || item.album_type == 2 || item.album_type == 8 || item.album_type == 3 || item.album_type == 4" v-text="$store.album_types[item.album_type]"></div>
          <div class="texts">
              <i v-if="rank > 0" v-text="rank"></i>
              <h3 v-text="item.artist.name"></h3>
              <h4 v-text="item.name"></h4>
              <span v-if="item.is_album == '1'" class="date" v-text="item.online_date_format"></span>
              <span v-else-if="item.songs.length > 1" class="date" v-text="item.online_date_format + ' | ' + item.songs.length + ' שירים'"></span>
          </div>
      </div>
</template>

<script>
  
export default {
  props: ["item", "rank"],
  data(){
    return {
    }
  },
  methods: {

  }
}
</script>